import { 
  showSuccessAlert,
  showSuccessAlertForm, 
  showInfoAlertArmas, 
  processErrors, 
  globalErrors, 
  showErrorAlert,
  globalInfoData
 } from './AlertHandler'
import Errors from "./Errors"

export function handleError(error, context) {
  if (error.response) {
    
    if (error.response.status === 422) {
      const errorData = error.response.data;
      if (errorData.errors) {
        for (const field in errorData.errors) {
          errorData.errors[field].forEach(errorMessage => {
            context.errors.value.push({ mensaje: errorMessage });
          });
        }
      }
    } else if (error.response.status === 401 || error.response.status === 409) {
      const resonseData = error.response.data;
      const message = resonseData.message;
      context.errors.value.push({ mensaje: message });
    } else if (error.response.status === 429) {
      context.errors.value.push({ mensaje: "Muchas consultas realizadas" });
    } else if (error.response.status === 500) {
      context.errors.value.push({ mensaje: "Ocurrió un error inesperado" });
      if (error.message === 'Request failed with status code 500') {
        context.errors.value.push({ mensaje: "Sin conexión al servidor de DATOS" });
      }
    } else if (error.response.status === 503) {
      context.errors.value.push({ mensaje: "Servicio en mantenimiento" });
    }
  } else {
    context.errors.value.push({ mensaje: "Problemas con el servidor" });
  }
}
/* SWEET ALERTS DATOS DEL BACK */
export function handleSweetInfo(info, context) {

  if (info.status === 200) {
    
    const message = info.data.message;
  
    if (info.data.length === 0) {
      showInfoAlertArmas();
    } else if (info.data.STATUS === "500") {

      const errorStatus = info.data.STATUS;
      globalErrors(message, errorStatus);
    } else {
      if (info.data.success === false) {
        processErrors(message);
      } else {
        if (info.data.formulario) {
          showSuccessAlertForm(message);
        } else {
          showSuccessAlert(message);
        }
      }
    }
  } else if (info.response) {
    if (info.response.status === 422) {

      const errorText = Errors.procesarErrores(info.response.data.errors);
      processErrors(errorText);
    } else if (info.response.status === 401 || info.response.status === 409) {
      /* LOGIN - CREDENCIALES INCORRECTAS Y SESION ACTIVA */
      context.errors.value.push({ mensaje: info.response.data.message });
    } else if (info.response.status === 429) {

      const errorStatus = info.response.status;
      globalErrors('Muchas consultas realizadas', errorStatus);
    } else if (info.response.status === 500) {

      const errorStatus = info.response.status;
      globalErrors('Ocurrió un error inesperado', errorStatus);
  
      if (info.message === 'Request failed with status code 500') {

        const errorStatus = info.response.status;
        globalErrors('Sin conexión al servidor de DATOS', errorStatus);
      }
    } else if (info.response.status === 503) {

      showInfoAlert('Servicio en mantenimiento');
    }
  } else {
    if (info == 'Error: No image') {
      const message = 'Falta cargar Fotografias'
      processErrors(message);
    }else {
      const message = 'Problemas con el servidor';
      showErrorAlert(message);
    }
  }
  
} 
/* SWEET ALERTS DATOS DEL FRONT DE COMPONENTE A OTRO */
export function handleSweetFront(info, context) {
  const message = info;
  const dato = info.data;
  globalInfoData(message, dato)
} 